import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('ARTICLES_TAG').plugin(axiosPlugin, {template: "array"});

let fetchArticlesTagAction = redux.fetchActionGet();


export const fetchArticlesTag = (query = {}) => fetchArticlesTagAction(`/articles?${queryString.stringify(query)}`);
export const resetArticlesTag = () => redux.actions.reset();

export const articlesTag = redux.reducer();